module.exports = __webpack_public_path__ + "static/media/compress-wide.5adbb360.svg";